export abstract class ComponentCanDeactivate {

    abstract canDeactivate(): boolean;
}



// WEBPACK FOOTER //
// ./src/app/services/guarad/component-can-deactivate.ts